/**
 * @desc sendProcessCreateEvent
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(data: defs.FlowProcessCreateEvent): Promise<any> {
  return defHttp.post({
    url: '/flow/process/create/event',
    data,
  });
}

export function mock(data: defs.FlowProcessCreateEvent): Promise<any> {
  return defHttp.post({
    url: '/mock/flow/process/create/event',
    data,
  });
}
